import React from 'react'
import TagsInput from '../Forms/TagsInput'
import { inject, observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'



const OrdersArticleSearchField = inject('ordersStore')(observer(props => {
    const { ordersStore, handleChange } = props
    const { t } = useTranslation()
    return (
        <TagsInput tags={ordersStore.articleSearchKeys} setTags={tags => handleChange(tags)} placeholder={t('orders:articleSearch')} />
    )
}))

export default OrdersArticleSearchField
